/*
 * @Description: 提交任务
 * @Date: 2025-05-26 18:10:43
 */
import { route } from './src/router';

const name = 'submit-task';
export { name, route };
